// Super simple service which allows other services to notify our custom route reuse strategy
// of situations which should govern how it operates
import { Injectable } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from '../../custom-route-reuse.strategy';

@Injectable({ providedIn: 'root' })
export class RouteReuseService {
    constructor(private routeReuseStrategy: RouteReuseStrategy) {}

    // Allows other services to notify our custom route reuse strategy that it should NOT reuse the home-page route
    // when it next navigates to it, but rather should initialize it from scratch (See https://community-dc.max.gov/x/bIWtnw for background)
    public setDoNotAttachHomePageOnNextNav(): void {
        //console.log('setDoNotAttachHomePageOnNextNav()');
        if (this.routeReuseStrategy instanceof CustomRouteReuseStrategy) {
            this.routeReuseStrategy.setDoNotAttachHomePageOnNextNav();
        }
    }
}
